// eslint-disable-next-line @typescript-eslint/no-var-requires
const tiersObj = require('./localization.data.json');

const locales = ['default', ...tiersObj['1'], ...tiersObj['2'], ...tiersObj['3'], ...tiersObj['4']];

const localization = {
  locales,
  defaultLocale: 'default',
};

module.exports = {
  localization,
  tiersObj,
  locales,
};
